import { createGlobalStyle, css } from "styled-components";
import reset from "styled-reset";

const root = css`
  :root {
    --color-theme-primary-100-rgb: ${props => props.theme.darkmode ? '195,195,200' : '65,65,70'};
    --color-theme-primary-200-rgb: ${props => props.theme.darkmode ? '45,45,50' : '185,185,190'};    
    --color-theme-primary-300-rgb: ${props => props.theme.darkmode ? '40,40,45' : '200,200,205'};
    --color-theme-primary-400-rgb: ${props => props.theme.darkmode ? '15,15,20' : '230,230,235'};
    --color-theme-primary-500-rgb: ${props => props.theme.darkmode ? '10,10,15' : '235,235,240'};
    --color-theme-primary-600-rgb: ${props => props.theme.darkmode ? '5,5,10' : '235,235,245'};
    
    --color-theme-secondary-400-rgb: 148,73,82;
    --color-theme-secondary-500-rgb: ${props => props.theme.darkmode ? '55,25,29' : '215,209,210'};

    --color-theme-accent-400-rgb: ${props => props.theme.darkmode ? '201,159,89' : '68,90,176'};
    --color-theme-accent-500-rgb: ${props => props.theme.darkmode ? '80,64,36' : '208,212,229'};

    --color-theme-primary-100: rgb(var(--color-theme-primary-100-rgb));
    --color-theme-primary-200: rgb(var(--color-theme-primary-200-rgb));
    --color-theme-primary-300: rgb(var(--color-theme-primary-300-rgb));
    --color-theme-primary-400: rgb(var(--color-theme-primary-400-rgb));
    --color-theme-primary-500: rgb(var(--color-theme-primary-500-rgb));
    --color-theme-primary-600: rgb(var(--color-theme-primary-600-rgb));
        
    --color-theme-secondary-400: rgb(var(--color-theme-secondary-400-rgb));
    --color-theme-secondary-500: rgb(var(--color-theme-secondary-500-rgb));

    --color-theme-accent-400: rgb(var(--color-theme-accent-400-rgb));
    --color-theme-accent-500: rgb(var(--color-theme-accent-500-rgb));

    --window-border: var(--color-theme-primary-200);
    --window-background: var(--color-theme-primary-400);
    
    --button-background: rgba(var(--color-theme-secondary-400-rgb), 0.25);
    --button-color: var(--color-theme-secondary-400);

    --border-radius: 0;
    --border-width: 1px;
    --border-style: solid;
    --border-color: var(--color-theme-primary-300);
    --border: var(--border-width) var(--border-style) var(--border-color);

    --font-family: 'Inter', sans-serif;
    --font-family-display: 'Orbitron', sans-serif;
    
    --font-size-xs: 8px;
    --font-size-sm: 10px;
    --font-size-md: 12px;
    --font-size-lg: 16px;
    --font-size-xl: 18px;
    --font-size-2xl: 20px;
    --font-size-3xl: 22px;
    --font-size-4xl: 24px;
    --font-size-5xl: 26px;
    --font-size-6xl: 28px;

    --line-height: 1.5;
    --line-height-display: 1;

    --space-base: 4px;
    --space-0: calc(var(--space-base) * 0);
    --space-1: calc(var(--space-base) * 1);
    --space-2: calc(var(--space-base) * 2);
    --space-3: calc(var(--space-base) * 3);
    --space-4: calc(var(--space-base) * 4);
    --space-5: calc(var(--space-base) * 5);
    --space-6: calc(var(--space-base) * 6);
    --space-7: calc(var(--space-base) * 7);
    --space-8: calc(var(--space-base) * 8);
    --space-9: calc(var(--space-base) * 9);
    --space-10: calc(var(--space-base) * 10);
    --space-11: calc(var(--space-base) * 11);
    --space-12: calc(var(--space-base) * 12);
  }
`;

const GlobalStyle = createGlobalStyle`
  ${reset}
  ${root}

  html,
  body,
  #root {
    height: 100%;
  }

  html {
   box-sizing: border-box;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  body {
    background-color: var(--color-theme-primary-500);
    color: var(--color-theme-primary-100);
    font-family: var(--font-family);
    font-size: var(--font-size-md);
    font-weight: 200;
    line-height: var(--line-height);
    user-select: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: var(--font-family-display);
    font-weight: 600;
    line-height: var(--line-height-display);
  }

  label,
  strong,
  b {
    font-weight: 600;
  }

  label {
    display: block;
    margin-bottom: var(--space-1);
  }

  input:not([type="checkbox"]),
  select {
    appearance: none;
    background-color: transparent;
    border: var(--border-width) var(--border-style) var(--color-theme-primary-200);
    color: inherit;
    display: block;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    height: var(--space-10);
    padding-inline: var(--space-2);
    width: 100%;
  }

  input[type="number"] {
    appearance: textfield;
    max-width: calc(var(--space-4) + 6ch);
  }
`;

export default GlobalStyle;
